import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Checkbox from '@components/form/Checkbox';
import Modal from '@components/modal/Modal';
import useEditTag from './hooks/useEditTag';

const EditTagModal = ({ id }: EditTagModalProps) => {
    const {
        handleSubmit,
        handleChange,
        closeModal,
        isPosting,
        formState: { name, isPublic },
    } = useEditTag(id);

    return (
        <Modal title="Edit Tag" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        name="name"
                        value={name}
                        onChange={handleChange}
                        label="Name"
                        placeholder="Name of this tag"
                        required
                    />
                </FormRow>

                <FormRow>
                    <Checkbox
                        name="isPublic"
                        label="Is public?"
                        value={isPublic}
                        onChange={handleChange}
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface EditTagModalProps {
    id: number;
}
export default EditTagModal;
